export default __webpack_public_path__ + "static/media/jerome.bad435a6.png";